import script from "./ViewRoomTemperatureRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRoomTemperatureRecord.vue?vue&type=script&setup=true&lang=js"

import "./ViewRoomTemperatureRecord.vue?vue&type=style&index=0&id=2f51df84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f51df84"]])

export default __exports__